import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import Toggle from 'material-ui/Toggle';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import _ from 'lodash';
import * as Colors from 'material-ui/styles/colors';
import transitions from 'material-ui/styles/transitions';
import AnimateContentDimensionChange from 'shared/components/AnimateContentDimensionChange/AnimateContentDimensionChange';
import AbstractListerField from './AbstractListerField';
import {FIELD_WIDTH} from '../consts';
import TooltipWrapper from 'shared/components/TooltipWrapper';
export default class ListerToggle extends AbstractListerField {
  handleToggle = (event, value) => {
    const {onChange} = this.props;
    onChange(value);
  };

  renderInsideWrapper(toggle) {
    const {value, children, width} = this.props;
    const expandedToggle = !!(value && children);
    return (
      <AnimateContentDimensionChange
        path={`${expandedToggle}_${React.Children.count(children)}`}
        style={{
          flexGrow: width === FIELD_WIDTH.FULL ? 1 : undefined,
          transition: transitions.easeOut('250ms'),
          backgroundColor: expandedToggle ? Colors.grey50 : Colors.transparent,
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column',
          padding: 20,
          justifyContent: 'space-around',
          position: 'relative',
          left: -20,
        }}
      >
        {toggle}
        {expandedToggle && children}
      </AnimateContentDimensionChange>
    );
  }

  render() {
    const {value, toggleHint, children, id} = this.props;
    const tooltip = !!value ? 'Click to disable' : 'Click to enable';
    let toggle = (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'baseline',
        }}
      >
        <TooltipWrapper tooltip={tooltip} popoverType={'grey'}>
          <Toggle
            id={id}
            labelPosition="left"
            style={{width: 'auto'}}
            toggled={!!value}
            onToggle={this.handleToggle}
            labelStyle={{whiteSpace: 'nowrap'}}
            {..._.pick(this.props, ['disabled', 'readOnly', 'label'])}
          />
        </TooltipWrapper>
        <div style={{color: Colors.grey400, whiteSpace: 'nowrap', marginLeft: 16, fontWeight: 300}}>{toggleHint}</div>
      </div>
    );
    if (children) {
      toggle = this.renderInsideWrapper(toggle);
    }
    return toggle;
  }
}

ListerToggle.propTypes = {
  onChange: PropTypes.func,
  required: PropTypes.bool,
};
